<template>
  <div class="inn-info">
    <div class="inn-info__input" v-if="!isFopFormParent && firmInfo.pdv_code">
      <label class="typo__label">{{ $t('VATIN') }}</label>
      <div class="inn-info__input-wrapper">
        <Input disabled class="inn-info__input-element" :value="firmInfo.pdv_code"/>
        <InnCheckMark :isFopFormParent="isFopFormParent" :isPdvPayer="isPdvPayer" :isValidInn="!!isValidInn"/>
      </div>
    </div>
    <div class="user-logged-form__semi-item inn-info__input" v-else-if="isFopFormParent">
      <label class="typo__label">{{ $t('VATIN') }}</label>
      <div class="inn-info__input-wrapper">
        <Input
          :maxLength="12"
          :regexp="/[^\d]/g"
          class="inn-info__input-element"
          :error="errorMessage"
          :value="formData.legalPersonInfo.inn"
          ref="innInput"
          :disabled="loadingComponents.legalPersonPayment"
          @input="handleInput"/>
        <InnCheckMark :isFopFormParent="isFopFormParent" :isPdvPayer="isPdvPayer" :isValidInn="!!isValidInn"/>
      </div>
    </div>
    <InnCheckMark v-else
                  :isFopFormParent="isFopFormParent"
                  :isPdvPayer="isPdvPayer"
                  :isValidInn="!!isValidInn"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InnCheckMark from './InnCheckMark'
import Input from '../../../inputs/Input'

export default {
  name: 'INNInput',
  components: { Input, InnCheckMark },
  props: {
    firmInfo: {
      type: Object,
      required: false
    },
    isFopFormParent: Boolean
  },
  data () {
    return {
      isEmptyPaymentWarning: true
    }
  },
  computed: {
    ...mapState({
      formData: state => state.checkout.formData,
      isPaymentFormEmpty: state => state.paymentForm.isPaymentFormEmpty,
      loadingComponents: state => state.checkout.loadingComponents,
      needValidation: state => state.checkoutNew.needValidation
    }),
    isPdvPayer () {
      // Проверяет является ли пользователь плательщиком пдв
      if (!this.formData.legalPersonInfo.hasOwnProperty('pdv_status')) {
        return undefined
      }
      if (this.formData.legalPersonInfo.hasOwnProperty('pdv_status')) {
        return this.formData.legalPersonInfo.pdv_status
      }
      return !this.isFopFormParent && this.formData.legalPersonInfo.pdv_status
    },
    isValidInn () {
      return this.isFopFormParent && this.formData.legalPersonInfo.status !== 'error'
    },
    incorrectData () {
      return this.formData.legalPersonInfo.hasOwnProperty('status') && this.formData.legalPersonInfo.status === 'error'
    },
    errorMessage () {
      if (this.incorrectData) return this.$t('field_incorrect_data')
      else if (this.isPaymentFormEmpty && this.isEmptyPaymentWarning) return this.$t('blank_field_error')
      else return ''
    }
  },
  methods: {
    ...mapActions(['FETCH_LEGAL_INFO_BY_CODE', 'SET_FORM_DATA', 'SET_IS_PAYMENT_FORM_EMPTY_WARNING']),
    ...mapActions('paymentNew', [
      'SET_LEGAL_PERSON_INFO'
    ]),
    validateMethods () {
      if (!this.firmInfo.pdv_code && !this.isFopFormParent) {
        this.SET_IS_PAYMENT_FORM_EMPTY_WARNING(true)
        this.isEmptyPaymentWarning = true
      } else if (!this.firmInfo.inn && this.isFopFormParent) {
        this.SET_IS_PAYMENT_FORM_EMPTY_WARNING(true)
        this.isEmptyPaymentWarning = true
      } else {
        this.SET_IS_PAYMENT_FORM_EMPTY_WARNING(false)
        this.isEmptyPaymentWarning = false
      }
    },
    handleInput (inn) {
      this.SET_FORM_DATA({
        legalPersonInfo: { formId: this.formData.legalPersonInfo.formId, formRef: this.formData.legalPersonInfo.formRef, inn }
      })
      this.SET_LEGAL_PERSON_INFO({ formId: this.formData.legalPersonInfo.formId, formRef: this.formData.legalPersonInfo.formRef, inn })
      if (inn.length === 10 || inn.length === 12) {
        this.FETCH_LEGAL_INFO_BY_CODE({
          code: inn,
          isFilia: false
        }).then(() => {
          this.isEmptyPaymentWarning = false
        })
      }
    }
  },
  mounted () {
    // Получение инн из истории заказов
    const inn = this.formData?.legalPersonInfo?.inn || ''

    if (inn && (inn.length === 10 || inn.length === 12)) {
      this.isEmptyPaymentWarning = false
    }
  },
  watch: {
    needValidation () {
      this.validateMethods()
    }
  }
}
</script>

<style scoped lang="sass">

  p
    margin: 0

  .inn-info
    display: flex
    margin-bottom: 15px

    .user-logged-form__semi-item
      margin-top: 0

  .inn-info__input
    display: flex
    flex-direction: column
    margin-top: 15px
    margin-bottom: 0
    width: 100%

  .inn-info__input-element
    font-size: 18px
    margin-right: 20px
    width: 48%

    +mmax($small)
      width: 48%

    +mmax(450)
      width: 100%

  .inn-info__input-wrapper
    display: flex
    align-items: center
    margin-top: 5px

    +mmax($small)
      flex-direction: column
      align-items: flex-start

</style>
